import React from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import FfinLogo from '@/assets/images/FfinBigImage.svg';
import { BigTitle, SubTitle } from '@/components';
import InfoBlock from '@/components/ui/info-block/info-block';

function LandingInfoBlock2() {
  const { t } = useTranslation();
  const Info = [
    { title: t('info_landing.info_block_2.block_1.title'), caption: t('info_landing.info_block_2.block_1.caption') },
    { title: t('info_landing.info_block_2.block_2.title'), caption: t('info_landing.info_block_2.block_2.caption') },
    { title: t('info_landing.info_block_2.block_3.title'), caption: t('info_landing.info_block_2.block_3.caption') },
    { title: t('info_landing.info_block_2.block_4.title'), caption: t('info_landing.info_block_2.block_4.caption') },
    { title: t('info_landing.info_block_2.block_5.title'), caption: t('info_landing.info_block_2.block_5.caption') },
    { title: t('info_landing.info_block_2.block_6.title'), caption: t('info_landing.info_block_2.block_6.caption') }
  ];
  return (
    <div>
      <BigTitle
        text={t('info_landing.info_block_2.title')}
        twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] mb-20`}
      />
      <div tw='flex flex-col sm:grid grid-cols-2 mb-10'>
        <div>
          <div tw='grid grid-cols-2 row-gap-10 col-gap-10 mb-10'>
            {Info.map(item => (
              <InfoBlock caption={item.caption} title={item.title} key={item.title} />
            ))}
          </div>
          <InfoBlock title={'B-/B, прогноз стабильный'} caption={'Рейтинг холдинга от S&P Global Ratings'} />
        </div>
        <div tw='flex flex-col justify-center items-center sm:mt-0 mt-10'>
          <img src={FfinLogo} alt='logo' tw='max-w-[300px]' />
          <SubTitle
            text={
              <span>
                Акции холдинга размещены <br />
                на бирже Nasdaq
              </span>
            }
            twStyle={tw`text-secondary leading-5 mt-3 text-center`}
          />
        </div>
      </div>
      <div tw='sm:text-left text-center'>
        <SubTitle text={t('info_landing.info_block_2.actual_date')} twStyle={tw`text-secondary`} />
      </div>
    </div>
  );
}

export default LandingInfoBlock2;
